import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { WlEventsV4ToolbarEvent } from './toolbar-events-v4-broadcast-event.model';

/**
 * service to broadcast events happening to or from the events toolbar
 */
@Injectable()
export class WlEventsV4ToolbarBroadcastService extends Subject<WlEventsV4ToolbarEvent> {
  /**
   * construct
   */
  public constructor() {
    super();
  }

  /**
   * broadcast an event
   * @param event
   */
  public broadcast(event: WlEventsV4ToolbarEvent): void {
    this.next(event);
  }
}
